import { Card, Col, Row } from 'reactstrap';
import Parametros from 'models/Parametros';
import Subtitle from 'views/components/Subtitle';
import { TextField, MenuItem } from '@material-ui/core';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import { useContext, useEffect } from 'react';
import { PropostaContext } from 'views/pages/Proposta';
import { iAcessoPrograma, iPropostaDados } from '../..';

export default function VariaveisComerciais({
  propostaVersao,
  isModoSimulacao,
  onChange,
  acessoPrograma,
  parametros,
  isRegramentoGeral,
  tipoGerar,
}: {
  propostaVersao: iPropostaDados;
  isModoSimulacao: boolean;
  onChange: (a: iPropostaDados) => void;
  acessoPrograma: iAcessoPrograma;
  parametros?: Parametros;
  isRegramentoGeral: boolean;
  tipoGerar: string;
}): JSX.Element {
  console.log('DADOS INICIAIS DA PROPOSTA VERSAO:', propostaVersao);

  const incentivoOptions = [
    { value: 'RECAP', name: 'RECAP' },
    { value: 'REINF', name: 'REINF' },
    { value: 'REPRO', name: 'REPRO' },
  ];

  function changeRootValue(campo: string, valor: string) {
    onChange({
      ...propostaVersao,
      [campo]: valor,
    });
  }

  async function changeValue(
    campo: string,
    valor: number,
    temNaPrecificacao?: boolean,
  ) {
    onChange({
      ...propostaVersao,
      valores: {
        ...propostaVersao.valores,
        [campo]: valor,
      },
      // Alguns valores constam tanto na proposta_versao quanto na precificação
      precificacao: propostaVersao.precificacao.map(item => {
        if (!temNaPrecificacao) return item;

        return {
          ...item,
          [campo]: valor,
        };
      }),
    });
  }

  return (
    <Card className="shadow p-3">
      <Subtitle name="Variáveis comerciais" />
      <Row className="px-2">
        <Col
          className="mb-2"
          md="3"
          hidden={propostaVersao.outros?.isRegramentoGeral}
        >
          <TextField
            label="Licenciamento (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualLicenciamento ?? 0}
            onChange={e =>
              changeValue('percentualLicenciamento', Number(e.target.value))
            }
            disabled={!isModoSimulacao}
          />
        </Col>
        <Col
          className="mb-2"
          md="3"
          hidden={propostaVersao.outros?.isRegramentoGeral}
        >
          <TextField
            label="Topografia (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualTopografia ?? 0}
            onChange={e =>
              changeValue('percentualTopografia', Number(e.target.value))
            }
            disabled={!isModoSimulacao}
          />
        </Col>

        <Col
          className="mb-2"
          md="3"
          hidden={isRegramentoGeral && tipoGerar === 'PS'}
        >
          <TextField
            label="Frete (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualFrete ?? 0}
            onChange={e =>
              changeValue('percentualFrete', Number(e.target.value))
            }
            disabled={!isModoSimulacao}
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Assistência Técnica (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualAssistenciaTecnica ?? 0}
            onChange={e =>
              changeValue(
                'percentualAssistenciaTecnica',
                Number(e.target.value),
              )
            }
            disabled={
              !isModoSimulacao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Taxa Flat (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualTaxaFlat ?? 0}
            onChange={e =>
              changeValue('percentualTaxaFlat', Number(e.target.value))
            }
            disabled={
              !isModoSimulacao || acessoPrograma.taxaFlat.acessoLimitado
            }
          />
        </Col>
        <Col
          className="mb-2"
          md="3"
          hidden={!propostaVersao.outros?.isRegramentoGeral}
        >
          <TextField
            label="Acessoria remota (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualAcessoriaRemota ?? 0}
            onChange={e =>
              changeValue('percentualAcessoriaRemota', Number(e.target.value))
            }
            disabled={
              !isModoSimulacao || !acessoPrograma.acessoriaRemota.temAcesso
            }
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Comissão Calculada (%)"
            type="number"
            className="mt-2"
            value={arredondaDecimais(
              propostaVersao.valores.percentualComissao ?? 0,
            )}
            onChange={e =>
              changeValue('percentualComissao', Number(e.target.value))
            }
            disabled={
              !isModoSimulacao ||
              propostaVersao.usuario.isIsentoComissao ||
              acessoPrograma.variaveisComerciais.acessoLimitado ||
              !acessoPrograma.comissao.temAcesso
            }
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Ajuste Comissão (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualAjusteComissao ?? 0}
            onChange={e =>
              changeValue('percentualAjusteComissao', Number(e.target.value))
            }
            disabled={
              !isModoSimulacao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Comissão Calculada + Ajuste (%)"
            type="number"
            className="mt-2"
            value={arredondaDecimais(
              (propostaVersao.valores.percentualComissao ?? 0) +
                (propostaVersao.valores.percentualAjusteComissao ?? 0),
            )}
            disabled
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Indicador de Negócio (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualIndicadorNegocio ?? 0}
            onChange={e =>
              changeValue('percentualIndicadorNegocio', Number(e.target.value))
            }
            disabled={
              !isModoSimulacao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          />
        </Col>

        <Col className="mb-2" md="3">
          <TextField
            label="Comissões a Receber (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualComissaoReceber ?? 0}
            onChange={e =>
              changeValue('percentualComissaoReceber', Number(e.target.value))
            }
            disabled={
              !isModoSimulacao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          />
        </Col>

        <Col className="mb-2" md="3" hidden={!isRegramentoGeral}>
          <TextField
            select
            label="Incentivo"
            className="mt-2"
            style={{
              width: 195,
            }} /* Forces it to match the default width of the other fields */
            value={propostaVersao.codigoIncentivo || ''}
            onChange={e =>
              changeRootValue('codigoIncentivo', e.target.value as string)
            }
            disabled={
              !isModoSimulacao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          >
            <MenuItem value="">Nenhum</MenuItem>
            {incentivoOptions.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Col>

        <Col
          className="mb-2"
          md="3"
          hidden={
            propostaVersao.variaveisComerciais.formatoMaoObra !== 'P' ||
            (isRegramentoGeral && tipoGerar === 'PS')
          }
        >
          <TextField
            label="M.O / Serviços (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualServicos ?? 0}
            disabled
          />
        </Col>

        <Col
          className="mb-2"
          md="3"
          hidden={!propostaVersao.outros?.isRegramentoGeral}
        >
          <TextField
            label="Seguro Garantia (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualSeguroGarantia ?? 0}
            onChange={e =>
              changeValue(
                'percentualSeguroGarantia',
                Number(e.target.value),
                true,
              )
            }
            disabled={!isModoSimulacao}
          />
        </Col>
        <Col
          className="mb-2"
          md="3"
          hidden={!propostaVersao.outros?.isRegramentoGeral}
        >
          <TextField
            label="Seguro Execução (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualSeguroExecucao ?? 0}
            onChange={e =>
              changeValue(
                'percentualSeguroExecucao',
                Number(e.target.value),
                true,
              )
            }
            disabled={!isModoSimulacao}
          />
        </Col>
        <Col
          className="mb-2"
          md="3"
          hidden={!propostaVersao.outros?.isRegramentoGeral}
        >
          <TextField
            label="Seguro Engenharia (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualSeguroEngenharia ?? 0}
            onChange={e =>
              changeValue(
                'percentualSeguroEngenharia',
                Number(e.target.value),
                true,
              )
            }
            disabled={!isModoSimulacao}
          />
        </Col>
        <Col
          className="mb-2"
          md="3"
          hidden={!propostaVersao.outros?.isRegramentoGeral}
        >
          <TextField
            label="Responsabilidade Civil (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualRespCivil ?? 0}
            onChange={e =>
              changeValue('percentualRespCivil', Number(e.target.value), true)
            }
            disabled={!isModoSimulacao}
          />
        </Col>
        <Col
          className="mb-2"
          md="3"
          hidden={!propostaVersao.outros?.isRegramentoGeral}
        >
          <TextField
            label="Riscos Trabalhistas (%)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.percentualRiscosTrabal ?? 0}
            onChange={e =>
              changeValue(
                'percentualRiscosTrabal',
                Number(e.target.value),
                true,
              )
            }
            disabled={!isModoSimulacao}
          />
        </Col>

        <Col className="mb-2" md="3" hidden={!propostaVersao.isExterior}>
          <TextField
            label="Valor Atual do Dólar Parametrizado (R$)"
            type="number"
            className="mt-2"
            value={parametros?.valorDolar ?? 0}
            disabled
          />
        </Col>

        <Col className="mb-2" md="3" hidden={!propostaVersao.isExterior}>
          <TextField
            label="Valor Dólar Cambial na Proposta (R$)"
            type="number"
            className="mt-2"
            value={propostaVersao.valores.valorDolar ?? 0}
            onChange={e => changeValue('valorDolar', Number(e.target.value))}
            disabled={
              !isModoSimulacao ||
              acessoPrograma.variaveisComerciais.acessoLimitado
            }
          />
        </Col>
      </Row>
    </Card>
  );
}
